import { render } from "./BuildupDrinks.vue?vue&type=template&id=895e28e6&scoped=true"
import script from "./BuildupDrinks.vue?vue&type=script&lang=js"
export * from "./BuildupDrinks.vue?vue&type=script&lang=js"

import "./BuildupDrinks.vue?vue&type=style&index=0&id=895e28e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895e28e6"]])

export default __exports__